<div class="login-box">
  <div class="lottie-animation">
    <ng-lottie [options]="options"> </ng-lottie>
  </div>
  <h2 class="sign-in">{{ "RESET_LINK_HEADER" | translate }}</h2>
  <p class="login-desc mb-3">{{ "INSTRUCTIONS" | translate }} {{ eMail }}.</p>
  <p class="login-desc mb-3">{{ "ADDITIONAL_INSTRUCTIONS" | translate }}</p>
  <p class="botom-action-line">
    {{ "BACK_TITLE" | translate }}
    <span routerLink="" class="login-now">{{
      "RESET_BACK_TO_LOGIN" | translate
    }}</span>
  </p>
</div>
